import { TableCell } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import { GifColors } from "../../../../theme";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: GifColors.lightGray,
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
    fontWeight:400,
    color:GifColors.generalBlack
  },
}))(TableCell);

export default StyledTableCell;